export interface IAdditionalAICreditPlan {
  credits?: number;
  price?: number;
  storyCreationLimit?: number;
  storyCreationCost?: number;
}

export enum CurrencyEnum {
  USD = 'usd',
  EUR = 'eur',
  GBP = 'gbp',
}

export const allCurrencies = Object.values(CurrencyEnum).map((currency) => currency.toLowerCase());

export interface IPlanPricing {
  currency: CurrencyEnum;
  cost: number;
  stripe_plan_id: string;
  isDefault?: boolean;
}

export interface PlanDetailsModel {
  id: string;
  name: string;

  // Multi-currency pricing support
  pricing?: IPlanPricing[];

  // Currency-specific display fields (added by backend based on user's country)
  displayCurrency?: CurrencyEnum;
  displayCost?: number;
  displayStripePlanId?: string;

  // Legacy fields for backward compatibility
  cost: string;
  chargeCycle: string | null;
  credits: number | string | null;
  storyCreationLimit: string | null;
  maxBookPage: number | string | null;
  trialDays?: number;
  freePhysicalBookStatus?: boolean;
  freePhysicalBookQuantity?: number;
  mics?: string;
  maintenanceMode?: boolean;
  additionalAICredit: IAdditionalAICreditPlan;

  showTopSubscription?: boolean;
  loader?: boolean;
}
